import { DutyCode, DutyHourType } from 'generated';

import {
  Holidays,
  OrganisationPreferences,
  TenantDetails,
  UserDetails,
  UserPreferences
} from './types';
import { Interval, PlanGroup, PlanUnit, WorkAgreement } from 'components/types';

import { PlanUnitType } from '../components/enums';

import { UserGrants } from 'utils/grants';

export const setUserDetails = (payload: UserDetails) => ({
  type: 'SET_USER_DETAILS',
  payload
});
export type UserDetailsAction = ReturnType<typeof setUserDetails>;

export const setTenantDetails = (payload: TenantDetails) => ({
  type: 'SET_TENANT_DETAILS',
  payload
});
export type TenantDetailsAction = ReturnType<typeof setTenantDetails>;

type fetchPlanUnitsOptions = {
  interval?: Interval;
  useEmployeePlanunits?: boolean;
  usePublicPlanUnits?: boolean;
  filterByType?: PlanUnitType;
};

export const fetchPlanUnits = (payload: fetchPlanUnitsOptions) => {
  return {
    type: 'FETCH_PLANUNITS',
    payload
  };
};
export type FetchPlanUnitsAction = ReturnType<typeof fetchPlanUnits>;

export const setPlanUnits = (payload: PlanUnit[]) => ({
  type: 'SET_PLANUNITS',
  payload
});
export type PlanUnitsAction = ReturnType<typeof setPlanUnits>;

export const setEmployeePlanUnits = (payload: PlanUnit[]) => ({
  type: 'SET_EMPLOYEE_PLANUNITS',
  payload
});
export type EmployeePlanUnitsAction = ReturnType<typeof setEmployeePlanUnits>;

export const setPublicPlanUnits = (payload: PlanUnit[]) => ({
  type: 'SET_PUBLIC_PLANUNITS',
  payload
});
export type PublicPlanUnitsAction = ReturnType<typeof setPublicPlanUnits>;

export const setPlanGroups = (payload: PlanGroup[]) => ({
  type: 'SET_PLANGROUPS',
  payload
});
export type PlanGroupsAction = ReturnType<typeof setPlanGroups>;

type SavePlanGroupPayload = {
  isNew?: boolean;
  id: string | number;
  name: string;
  costCenters: PlanUnit[];
};
export const savePlanGroup = ({
  isNew,
  name,
  costCenters,
  id
}: SavePlanGroupPayload) => ({
  type: isNew ? 'SAVE_NEW_PLANGROUP' : 'UPDATE_PLANGROUP',
  payload: { name, costCenters, id }
});
export type SavePlanGroupAction = ReturnType<typeof savePlanGroup>;

export const deletePlanGroup = (id: string | number) => ({
  type: 'DELETE_PLANGROUP',
  payload: id
});
export type DeletePlanGroupAction = ReturnType<typeof deletePlanGroup>;

export type UserPreference = {
  key: keyof UserPreferences;
  value:
    | string
    | number
    | boolean
    | null
    | []
    | Record<string, unknown>
    | (string | number)[];
  isDojoDispatch?: boolean;
};
export const setUserPreference = (payload: UserPreference) => ({
  type: 'SET_PREFERENCE',
  payload
});
export type UserPreferenceAction = ReturnType<typeof setUserPreference>;

export const setUserPreferences = (payload: UserPreferences) => ({
  type: 'SET_PREFERENCES',
  payload
});
export type UserPreferencesAction = ReturnType<typeof setUserPreferences>;

export const setUserGrants = (payload: UserGrants) => ({
  type: 'SET_GRANTS',
  payload
});
export type UserGrantsAction = ReturnType<typeof setUserGrants>;

export const setOrganisationPreferences = (
  payload: OrganisationPreferences
) => ({
  type: 'SET_ORG_PREF',
  payload
});
export type OrganisationPreferencesAction = ReturnType<
  typeof setOrganisationPreferences
>;

export const setDutyCodes = (payload: DutyCode[]) => ({
  type: 'SET_DUTYCODES',
  payload
});
export type DutyCodesAction = ReturnType<typeof setDutyCodes>;

export const setDhts = (payload: DutyHourType[]) => ({
  type: 'SET_DHTS',
  payload
});
export type DhtsAction = ReturnType<typeof setDhts>;

export const fetchHolidays = () => ({
  type: 'GET_HOLIDAYS'
});

export const setHolidays = (payload: Holidays) => ({
  type: 'SET_HOLIDAYS',
  payload
});
export type HolidaysAction =
  | ReturnType<typeof setHolidays>
  | ReturnType<typeof fetchHolidays>;

export const setWorkAgreements = (payload: WorkAgreement[]) => ({
  type: 'SET_WORK_AGREEMENTS',
  payload
});
export type WorkAgreementsAction = ReturnType<typeof setWorkAgreements>;

export type SetPreferencesAction = {
  type: 'SET_PREFERENCES';
  payload: UserPreferences;
};

export type SetPreferenceAction = {
  type: 'SET_PREFERENCE';
  payload: {
    key: keyof UserPreferences;
    value: UserPreferences[keyof UserPreferences];
  };
};

export type PrefAction = SetPreferencesAction | SetPreferenceAction;
